module.exports = __webpack_public_path__ + "static/sport/bgi-mb.3a10981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/bgi-mb.png
// module id = LM2h
// module chunks = 0